module.exports = __webpack_public_path__ + "img/success-with-woodpacking-bosspack-en.ba50b9e1.svg";